import { render, staticRenderFns } from "./kdbkifam.vue?vue&type=template&id=025280fe&"
import script from "./kdbkifam.vue?vue&type=script&lang=js&"
export * from "./kdbkifam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports